<template lang="pug">
  b-modal(
    :size="option.size || 'lg'"
    v-model="visible"
    @hide="close"
    hide-footer
    :modal-class="`common-popup ${className}`"
    :header-class="option.headerClass || ''"
    :no-close-on-esc="noCloseOnEsc"
  )
    template(slot="modal-header")
        span.title(v-if="title !== null") {{ title }}
        img.logo(src="@/assets/logo_popup.png")
    slot
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    className: {
      type: String,
      default: "",
    },

    noCloseOnEsc: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show(newVal) {
      this.visible = newVal
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    close() {
      this.$emit("update:show", false)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .modal {
    font-family: "Noto Sans Korean", "Malgun Gothic", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px;
    color: #000000;
  }

  .type-popup {
    padding: 0 !important;
    .modal-dialog {
      width: 100%;
      max-width: 100%;
      margin: 0;
      height: 100%;
      min-height: 100%;
    }
    .modal-content {
      height: 100%;
    }
  }

  .warning {
    text-align: center;
    .fa-icon,
    i,
    span {
      display: block;
      margin: 0 auto;
      color: #b20000;
    }
    span {
      font-size: 19px;
      font-weight: 500;
      color: #b20000;
      padding: 10px 0 0 0;
    }
  }
  .box {
    border: 1px solid #d2d2d2;
    margin-top: 5px;
    border-radius: 2px;
    padding: 5px 0;
  }
  .msg {
    font-size: 16px;
    text-align: center;
    padding: 10px 0;
  }
}
</style>
